<template>
    <div class="result-area longer">
      <p>Det finns förutsättningar för att du kan ha en nervrelaterad orsak till dina besvär. Försämrad nervfunktion kan påverka förmågan att få och bibehålla erektion. Det kan exempelvis bero på att ryggmärgen har skadats, eller efter kirurgi i området kring penis och prostata. Du kan också ha en nervrelaterad sjukdom som bryter ner nerverna, så kallad neurodegenerativ sjukdom. Förmodligen har du då redan kontakt med sjukvården, men om du inte skulle ha det rekommenderar vi att du kontaktar din vårdcentral.</p>
           
      <p v-if="hasAdditionalInfo_alt1">Enligt dina svar kan besvären även delvis bero på:
      
        <VueFaqAccordion 
          :items="getItems()"
          borderColor="transparent"
          fontColor="#2c3e50"
          activeColor="#2c3e50"
        />
        
      </p>

      <p>Vid <span v-if="hasAdditionalInfo_alt1">ovanstående orsaker till erektil dysfunktion</span><span v-else>flera neurologiska tillstånd</span> kan läkemedlet Sildenafil ha god effekt.</p>
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
import { INDICATOR } from '../../../config/indicators'

export default { 
  inject: ["formState"],
  components: {
    VueFaqAccordion
  },
  data() {
    return {
      additionalInfoOpsyk: "Nedstämdhet och stress kan både minska lust och förmågan till att få en användbar erektion. Relationen till sin tilltänkta partner kan också påverka. Psykologiska orsaker är vanligt hos yngre, där stress och osäkerhet inför att ha sex kan bidra till besvären, men förekommer i alla åldrar. Vi rekommenderar dig att ta kontakt med psykolog eller sexolog för diskussion om din situation.",

      additionalInfoOHorm: "Hormonet testosteron är viktigt för att kunna få och bibehålla erektion. Då misstanken uppkommit rekommenderas du att ta kontakt med din vårdcentral för en bredare diskussion kring dina symtom och om eventuell utredning bör göras."
    }
  },
  methods: {
    getItems() {

      let extraItems = [];

      if (this.hasAdditionalInfo_alt1) {
        let item_1 = {
          title: this.additionalInfoTrigger_alt1,
          value: this.additionalInfoTxt_alt1
        }

        extraItems.push(item_1)
      }

      if (this.hasAdditionalInfo_alt2) {
        let item_2 = {
          title: this.additionalInfoTrigger_alt2,
          value: this.additionalInfoTxt_alt2
        }

        extraItems.push(item_2)
      }

      return extraItems
      
    }
  },
  computed: {
    hasAdditionalInfo_alt1() {
      return this.formState.additionalInfo_alt1.length ? true : false
    },
    hasAdditionalInfo_alt2() {
      return this.formState.additionalInfo_alt2.length ? true : false
    },
    additionalInfoTrigger_alt1() {
      switch (this.formState.additionalInfo_alt1) {
        case (INDICATOR.O_PSYK): {
          return "Psykologisk orsak"
        }
        case (INDICATOR.O_HORM): {
          return "Hormonrelaterad orsak"
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTrigger_alt2() {
      switch (this.formState.additionalInfo_alt2) {
        case (INDICATOR.O_HORM): {
          return "Hormonrelaterad orsak"
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTxt_alt1() {
      switch (this.formState.additionalInfo_alt1) {
        case (INDICATOR.O_PSYK): {
          return this.additionalInfoOpsyk
        }
        case (INDICATOR.O_HORM): {
          return this.additionalInfoOHorm
        }
        default: {
          return ""
        }
      }
    },
    additionalInfoTxt_alt2() {
      switch (this.formState.additionalInfo_alt2) {
        case (INDICATOR.O_HORM): {
          return this.additionalInfoOHorm
        }
        default: {
          return ""
        }
      }
    },
  }
}
</script>